import { type IClientProviderPluginContext, type IClientProviderPlugin } from '@source-digital/sd-app-core'
import { type IBrokerContext } from '../context'
import { type Logger } from '../utils/logger'

export class BaseClientProviderPluginInstaller {
  ctx: IBrokerContext
  logger: Logger
  constructor (ctx: IBrokerContext, name: string) {
    this.ctx = ctx
    this.logger = ctx.logger.createLogger(name)
  }

  createContext (module: IClientProviderPlugin, id: string): IClientProviderPluginContext {
    return {
      messenger: this.ctx.rootMessenger.createLocalEmitter(id),
      apis: this.ctx.rootMessenger.createLocalClientApiManager(id)
    }
  }
}
